import React from 'react';
import { createFileRoute } from '@tanstack/react-router'
import { Box, Typography, Paper } from '@mui/material';
import { MoonPhaseDiagram } from '../components/menu/MoonWithPopup';
import LunarHelixCalendar from '../components/effects/LunarHelixCalendar';
import NavBar from '../components/menu/NavBar';
import { usePastFloodEvents } from '../layers/past_flood_events';

export const Route = createFileRoute('/lunar')({
  component: RouteComponent,
})

function RouteComponent() {
  const [initialDate] = React.useState<Date>(() => new Date());
  const [currentDate, setCurrentDate] = React.useState<Date>(initialDate);
  const { features: pastEvents, loading: pastLoading } = usePastFloodEvents();
  return (
    <>
    <NavBar />
    <Box
      sx={{
        // minHeight: '100dvh',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '320px 1fr' },
        gap: 3,
        p: { xs: 2, md: 4 },
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          position: { md: 'sticky' } as any,
          top: { md: 20 },
          alignSelf: 'start',
          p: 3,
          borderRadius: 3,
          background: 'background.paper',
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 700, textAlign: { xs: 'center', md: 'left' } }}>
          Lunar Cycle
        </Typography>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <MoonPhaseDiagram currentTime={currentDate} R={140} />
        </Box>
        <Typography
          variant="body2"
          sx={{ textAlign: { xs: 'center', md: 'left' }, color: 'text.secondary' }}
        >
          Today&apos;s position in the lunar cycle, plus the upcoming new, first-quarter, full, and last-quarter moons.
        </Typography>
      </Paper>

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderRadius: 3,
          background: 'background.paper',
          borderColor: 'divider',
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <LunarHelixCalendar
          startDate={initialDate}
          onSelectedDateChange={setCurrentDate}
          events={pastEvents as GeoJsonFeature[]}
          style={{ flex: 1, overflow: 'auto' }}
        />
      </Paper>
    </Box>
    </>
  );
}
